import { Box, Button, Stack, useTheme } from "@mui/material";
import type { FormEventHandler, ReactNode } from "react";
import { UnsavedChangesDrawer } from "web_myplann/Portfolio/PortfolioShared/UnsavedChangesDrawer";
import type { LeaveConfirmation } from "web_myplann/Shared/Hooks/useLeaveConfirmation";

type Props = {
	onSubmit: FormEventHandler<HTMLFormElement>;
	submitLabel: string;
	submitIcon?: ReactNode;
	disabled?: boolean;
	loading?: boolean;
	leaveConfirmation?: LeaveConfirmation;
	children: ReactNode;
};

export const PortfolioFormShell = ({
	onSubmit,
	submitLabel,
	submitIcon,
	disabled,
	loading,
	leaveConfirmation,
	children,
}: Props) => {
	const theme = useTheme();

	return (
		<Stack
			component="form"
			onSubmit={onSubmit}
			minHeight="100%"
			bgcolor={theme.palette.grey[50]}
		>
			<Box display="contents" inert={loading}>
				{children}
			</Box>

			<Box
				px={theme.spacingTokens.lg}
				pt={theme.spacingTokens.xl}
				pb={theme.spacingTokens.xxl}
			>
				<Button
					type="submit"
					variant="primary"
					startIcon={submitIcon}
					disabled={disabled}
					loading={loading}
				>
					{submitLabel}
				</Button>
			</Box>

			{leaveConfirmation && (
				<UnsavedChangesDrawer {...leaveConfirmation} loading={loading} />
			)}
		</Stack>
	);
};
